import { ChangeEvent, forwardRef, ForwardRefRenderFunction } from 'react';
import styles from './style.module.css';

export interface IRadioOption {
  value: string;
  label: string;
  disabled?: boolean;
}

interface IRadioGroup {
  name: string;
  options: IRadioOption[];
  value?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  errors?: string;
  label?: string | JSX.Element;
  column?: boolean;
  disabled?: boolean;
}

const RadioGroupBase: ForwardRefRenderFunction<
  HTMLInputElement,
  IRadioGroup
> = (
  { name, options, value, onChange, onBlur, errors, label, column, disabled },
  ref
) => {
  return (
    <>
      {label && <label>{label}</label>}
      <div className={`${styles.group} ${column ? styles.groupColumn : ''}`}>
        {options.map((option, index) => (
          <label
            key={option.value}
            className={`${styles.option} ${
              disabled || option.disabled ? styles.optionDisabled : ''
            }`}
          >
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={value === option.value}
              onChange={onChange}
              onBlur={onBlur}
              disabled={disabled || option.disabled}
              ref={index === 0 ? ref : undefined}
            />
            {option.label}
          </label>
        ))}
      </div>
      <span className={styles.error}>{errors}</span>
    </>
  );
};

export const RadioGroup = forwardRef(RadioGroupBase);
